// import * as React from "react";
import React, { useEffect, useState } from "react";
import "./index.css";
import "./viewdetail.css";
import {
  Modal,
  Row,
  Typography,
  Col,
  Image,
  Carousel,
  Tabs,
  Rate,
  List,
  Avatar,
  Button,
  Input,
  Form,
  message,
  notification,
  Pagination,
} from "antd";
import {
  UserOutlined,
  FacebookFilled,
  GooglePlusCircleFilled,
  TwitterCircleFilled,
} from "@ant-design/icons";
import GoogleLogin from "react-google-login";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

import Logo from "../../assets/logo_tripze.png";
import IconAddress from "../../assets/ic_address.png";
import AvatarDefault from "../../assets/ic_profile.png";
import locationTourApi from "../../service/locationTourService";
import locationServiceApi from "../../service/locationserviceService";
import eventApi from "../../service/eventService";
import serviceCategoryApi from "../../service/serviceCategoriesApi";
import reviewApi from "../../service/ReviewService";
import ratingApi from "../../service/RatingService";
import userApi from "../../service/userService";
import commentApi from "../../service/CommentService";
import { BASE_URL,BASE_IMAGE_URL, CLIENT_GOOGLE_ID,
  FACEBOOK_ID
 } from "../../service/apiConfig";
import LoginModal from "../../components/shares/loginModel";
import { Trans, useTranslation } from "react-i18next";
import { useSpeechSynthesis } from "react-speech-kit";
import { updateCurrentProfile } from "../../features/currentProfileRedux/currentProfile";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Parser from "html-react-parser";
import Utils from "../../components/shares/utils"
import Moment from 'react-moment';
import 'moment/locale/ko';
import 'moment/locale/ja';
import 'moment/locale/fr';
import 'moment/locale/de';
import 'moment/locale/vi';
import 'moment/locale/zh-cn';
import itemOpenHour from "../../components/card/itemOpenHour";

const { TabPane } = Tabs;
const { TextArea } = Input;

export default function ViewDetail({
  id,
  categoryId,
  tourData,
  locationTours,
  commentListInput,
  type,
  language,
}) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const [listTourData, setListTourData] = React.useState([]);
  const [isOpenComment, setIsOpenComment] = React.useState(false);
  const [isActionOpenComment, setActionOpenComment] = React.useState(false);
  const [locationNearest, setLocationNearest] = React.useState([]);
  const [rating, setRating] = React.useState(0);  
  const [evaluateRating, setEvaluateRating] = React.useState(5);
  const [commentList, setCommentList] = React.useState(commentListInput);
  const [isOpenLogin, setIsOpenLogin] = React.useState(false);
  const [form] = Form.useForm();
  const [dataDetail, setDataDetail] = React.useState(null);
  const { speak, cancel, speaking, supported, voices } = useSpeechSynthesis();
  const [totalItem, setTotalItem] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [audioStop, setAudioStop] = useState(true);
  const [activeTab, setActiveTab] = useState("1"); 
  const currentLanguage = useSelector((state) => state.currentLanguage);
  const currentProfile = useSelector((state) => state.currentProfile);

  const data = {
    latitude: dataDetail?.latitude,
    longitude: dataDetail?.longitude,
    page: currentPage,
    pageSize: 5,
    language: currentLanguage.language,
  };
  useEffect(() => {
    console.log(' View Detail start')
    setActiveTab("1")
    stopSpeed()
    // setVoice(window.speechSynthesis.getVoices())
    
    loadNearestData(data)    
        
    setCurrentPage(1)
    return () => {      
        cancel()      
    }
  }, [id, categoryId, type]);


  useEffect(() => {  
    // check action open comment 
    if(isActionOpenComment){
      setIsOpenComment(true) 
      setActionOpenComment(false)
    }    
  },[currentProfile])

  const loadNearestData = (data) => {
    if(!Utils.isShowMyAds(tourData)){
      if (type === "TOUR") {
        getNearDataTour(id, data);    
      } else if (type === "EVENT") {
        getNearDataEvent(id, data);
      } else {
        getNearDataService(categoryId, data);
      }
      getReviewData(id, type)
    }
    setDataDetail(tourData)
  }
  
  const getData = (id) => {
    if (type === "TOUR") {
      locationTourApi.getById(id, language).then(async (res) => {
        const dataTour = {
          ...res.data,
          pictureFilename: JSON.parse(res.data.pictureFilename),
        };
        getReviewData(id, type);
        setDataDetail(dataTour);
      });
    } else if (type === "SERVICES") {
      locationServiceApi.getById(id, language).then(async (res) => {
        const dataService = {
          ...res.data,
          pictureFilename: JSON.parse(res.data.pictureFilename),
        };
        getReviewData(id, type);
        setDataDetail(dataService);
      });
    } else {
      eventApi.getById(id, language).then(async (res) => {
        const dataEvent = {
          ...res.data,
          pictureFilename:
            res.data.pictureFilename != null
              ? JSON.parse(res.data.pictureFilename)
              : null,
        };
        getReviewData(id, type);
        setDataDetail(dataEvent);
      });
    }
  };

  const getNearDataEvent = (id) => {
    eventApi.getallnearest(data).then((res) => {
      setTotalItem(res.totalData);
      const listTemp = [];
      res.data.forEach((item) => {
        const temp = {
          ...item,
          pictureFilename: JSON.parse(item.pictureFilename),
        };
        listTemp.push(temp);
      });
      setLocationNearest(listTemp);
    });
  };
  const getNearDataService = (id, data) => {
    serviceCategoryApi.getById(id, data).then((res) => {
      setTotalItem(res.totalData);
      const listTemp = [];
      res.data.forEach((item) => {
        const temp = {
          ...item,
          pictureFilename: JSON.parse(item.pictureFilename),
        };
        listTemp.push(temp);
      });
      setLocationNearest(listTemp);
    });
  };

  const getNearDataTour = (id, data) => {    
    locationTourApi.getNearestLocation(data).then((res) => {
      setTotalItem(res.totalData);
      const listTemp = [];
      res.data.forEach((item) => {
        const temp = {
          ...item,
          pictureFilename: JSON.parse(item.pictureFilename),
        };
        listTemp.push(temp);
      });
      setLocationNearest(listTemp);
    });
    locationTourApi.getAll().then((res) => {
      const listTour = [];
      res.data.forEach((item) => {
        if (item.id !== id) {
          listTour.push(item);
        }
      });
      setListTourData(listTour);
    });
  };

  const getReviewData = () => {
    reviewApi.getReview({ id, type }).then((res) => {
        setRating(parseFloat(res.data?.totalRating));
        setCommentList(res.data?.comment)        
    });
  };

  const checkUserId = () => {    
   return  userApi.getUserLocal()
  }

  const onFinishComment = async (value) => {
    const findUser = checkUserId()
    if (findUser) {
      const dataComment = {
        userId: findUser.id,
        content: value.comment,
        rating: evaluateRating,
        entityTypeId: id,
        entityType: type,
      };
      try {        
        const addCmt = await commentApi.createComment(dataComment);
        // notification.success({ message: `Đánh giá thành công` });
        setEvaluateRating(0);
        form.setFieldsValue({ comment: "" });
        setIsOpenComment(false);
        getReviewData();
      } catch (error) {
        // notification.success({ message: `Đánh giá bị lỗi` });
      }
    } else {
      setIsOpenLogin(true);
    }
  };
  const onChangePaging = (pageNumber) => {
    setCurrentPage(pageNumber);
    const data = {
      latitude: dataDetail?.latitude,
      longitude: dataDetail?.longitude,
      page: pageNumber,
      pageSize: 5,
      language: currentLanguage.language,
    };
    if (type === "TOUR") {
      getNearDataTour(id, data);
    } else if (type === "EVENT") {
      getNearDataEvent(id, data);
    } else {
      getNearDataService(categoryId, data);
    }
    setDataDetail(tourData);
  };
  const onFinish = (values) => {
    console.log("Success:", values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onCloseLogin = () => {
    setIsOpenLogin(false);
  };

  const onChangeRating = (value) => {
    setEvaluateRating(value);
  };

  const onClickNearBy = (values) => {
    const data = {
      latitude: dataDetail?.latitude,
      longitude: dataDetail?.longitude,
      page: 1,
      pageSize: 5,
    };
    loadNearestData(data)
    getData(values.id);
  };

  const onSuccessGoogle = (response) => {
    userApi
      .createUserCustomer({
        userName: response.profileObj.name,
        email: response.profileObj.email,
        firstName: response.profileObj.givenName,
        lastName: response.profileObj.familyName,
        loginType: 'Google',
      })
      .then((response) => {
        if (response.data != null) {
          userApi.setUserLocalStorage(response.data)
          dispatch(updateCurrentProfile(response.data))       
          // localStorage.setItem("userID", response.data.id);
          // localStorage.setItem("userName", response.data.userName);
          // localStorage.setItem("email", response.data.email);
        }
        setIsOpenLogin(false);
        stopSpeed()
        // window.location.reload();
      });
  };
  const responseFacebook = (response) => {
    userApi
      .createUserCustomer({
        userName: response.name,
        email: response.email,
        loginType: 'Facebook',
      })
      .then((response) => {
        if (response.data != null) {
          userApi.setUserLocalStorage(response.data)
          dispatch(updateCurrentProfile(response.data))       
          // localStorage.setItem("userID", response.data.id);
          // localStorage.setItem("userName", response.data.userName);
          // localStorage.setItem("email", response.data.email);
        }
        // message.success(response.message);
        setIsOpenLogin(false);
        stopSpeed()
        // window.location.reload();
      });
  };
  const responseGoogle = (response) => {
    console.log(response);
  };

  const stopSpeed = () => {
    if (speaking) {                        
      cancel()
    }
  }

  const noDataComment = () => (
    <div align="center" style={{marginTop: 20, marginBottom: 20}}>
    <span style={{color:'#ccc' , fontWeight: "500", fontSize: "15px"}}>
    {t('content.noDataComment')}
    </span>
    </div>
  )
  // const SpeechSynthesisVoice = {
  //   default: false,
  //   lang: currentLanguage.language,
  //   localService: true,
  // };
  return (
    <>
      <Row justify="space-between" >
        <Col sm={24} md={12}>
          <Carousel style={{ width: "100%" }} autoplay>
            {dataDetail?.pictureFilename?.map((x, idx) => (
              <div key={idx}>
                <Image
                  style={{ borderRadius: "25px" }}
                  width={"100%"}
                  src={`${BASE_IMAGE_URL}${x}`}
                />
              </div>
            ))}
          </Carousel>
          <Tabs defaultActiveKey={activeTab} >
            <TabPane tab={t("content.information")} key="1">
              <h1>{dataDetail?.title}</h1>
              {!Utils.isShowMyAds(dataDetail) ? <div>
              <span style={{ fontWeight: "500", fontSize: "15px" }}>
                {/* Đánh giá: */}
                {t("content.rating")}:
              </span>
              <Rate
                style={{ marginLeft: "10px" }}
                allowHalf
                disabled
                value={dataDetail?.totalRating}
              />
              <br />
              <span><Image   
                  style={{ paddingRight: "10px" }}
                  width={"30px"}
                  height={"15px"}
                  src={IconAddress}
                />{dataDetail?.address}</span>
              {dataDetail?.eventCategoryId ? <div>
                <span style={{ fontWeight: "500", fontSize: "15px" }}>                  
                  {t("content.operatingDate")}:
                </span>
                <span style={{ marginLeft: "10px" }}>{ Utils.displayDayItem(dataDetail?.dateTimeOpen, dataDetail?.dateTimeClose, currentLanguage.language)}</span>
              </div> : itemOpenHour(dataDetail, t)
            //   <div>
            //   <span style={{ fontWeight: "500", fontSize: "15px" }}>                
            //     {/* {t("content.operatingHours")}:                 */}
            //     {Utils.showTitleOpenHour(t, dataDetail?.dateTimeOpen, dataDetail?.dateTimeClose)}
            //   </span>
            //   <span style={{ marginLeft: "10px" }}>{Utils.displayTimeStatus(dataDetail?.dateTimeOpen, dataDetail?.dateTimeClose)}</span>
            // </div>
              }
              {type === "TOUR" ? <div>
                <span style={{ fontWeight: "500", fontSize: "15px" }}>
                {t("content.unitPrice")}:                 
                </span>
                <span style={{ marginLeft: "10px" }}>{ Utils.displayUnitprice(dataDetail?.unitPrice, t('content.unitPriceFree'))}</span>
              </div> : null 
              }
              {type === "EVENT" && dataDetail?.website != null ? <div>
                <span style={{ fontWeight: "500", fontSize: "15px" }}>
                {t("content.website")}:                 
                </span>
                <span style={{ marginLeft: "10px" }}><a href={dataDetail?.website} target="_blank">{dataDetail?.website}</a></span>
              </div> : null 
              }  
              </div> : null }

              <div>
                <span style={{ fontWeight: "500", fontSize: "15px" }}>
                  {/* Mô Tả: */}
                  {t("content.description")}:
                </span>
                <span style={{ marginLeft: "10px" }}>
                  {Parser(dataDetail?.description ?? '')}
                </span>
              </div>
              <br />
              { (dataDetail?.description != '' && dataDetail?.description != null && !Utils.isShowMyAds(dataDetail)) ? <div>
                <button
                  className="btn btn-primary btn-lg"
                  onClick={() => { 
                      stopSpeed()
                      if (!speaking) {                      
                        speak({
                          text: dataDetail?.description,
                        })                        
                      }                    
                  }
                }
                >
                 {speaking ? t("content.audioStop") : t("content.audio")}
                </button>
              </div> : null } 
            </TabPane>
            {!Utils.isShowMyAds(dataDetail) ? <TabPane tab={t("content.comment")} key="2">
            {commentList?.length >0  ? <List
                itemLayout="horizontal"
                dataSource={commentList}                
                renderItem={(item) => (
                  <List.Item>
                    <List.Item.Meta
                      avatar={
                        item.avatar ? <Avatar src={Utils.avatar(item.avatar)}></Avatar>  : <Avatar src={Utils.avatar(item.avatar)} srcSet={AvatarDefault}></Avatar> 
                      }
                      title={
                        <div>
                          <Row justify="space-between">
                          <Col md={12} style={{width:'100%'}}>
                            <span>{item.userName}</span>  
                          </Col>
                          <Col md={12} style={{width:'100%'}} align="right" >
                            <span ><Moment locale={i18n.language} fromNow>{item.updatedAt}</Moment></span>
                          </Col>
                          </Row>
                                                    
                          <span>                            
                          <Rate
                            style={{ marginLeft: "1px" }}
                            disabled
                            value={item.rating}
                          /></span>
                        </div>                        
                      }
                      description={item.content}
                    />
                  </List.Item>
                )}
              /> : noDataComment() }
              <Button
                type="primary"
                style={{
                  backgroundColor: "orange",
                  borderColor: "orange",
                  width: "100%",
                  height: "50px",
                  fontSize: "20px",
                }}
                onClick={() => {
                  setActionOpenComment(true)
                  if (checkUserId() != null) {
                    setIsOpenComment(true);
                    setActionOpenComment(false)
                  } else {
                    setIsOpenLogin(true);
                    stopSpeed()
                  }
                }}
              >
                {t("content.writeReview")}
                {/* Đánh giá */}
              </Button>
            </TabPane> : null }
          </Tabs>
        </Col>
        {!Utils.isShowMyAds(dataDetail) ? <Col sm={24} md={10} className="locations-nearly">
          <div>
            <span style={{ fontWeight: "500", fontSize: "15px" }}>
              {/* Địa điểm gần đây: */}
              {t("content.nearbyPlaces")}:
            </span>
            <List
              itemLayout="horizontal"
              dataSource={locationNearest}
              renderItem={(item) => (
                <List.Item>
                  <List.Item.Meta
                    avatar={
                      item.pictureFilename?.length > 0 ? (
                        <div style={{ width: "100px" }}>
                          <Carousel autoplay={true} dots={false}>
                            {item.pictureFilename.map((e, idx) => (
                              <Image key={idx}
                                style={{
                                  borderRadius: "25px",
                                  width: "100px",
                                  height: "100px",
                                }}
                                src={`${BASE_IMAGE_URL}/${e}`}
                              />
                            ))}
                          </Carousel>
                        </div>
                      ) : (
                        <Image
                          src={`${BASE_IMAGE_URL}/images/avatar.jpg`}
                          style={{ width: "60px" }}
                        />
                      )
                    }
                    title={
                      <a
                        onClick={() => {
                          onClickNearBy(item);
                        }}
                      >
                        {item.title}
                      </a>
                    }
                    description={
                      <div>
                        <span>{item.address}</span>
                        <br />
                        <Rate disabled defaultValue={item.totalRating} />
                      </div>
                    }
                  />
                </List.Item>
              )}
            />
            <Row justify="center">
              <Pagination
                current={currentPage}
                total={totalItem}
                pageSize={5}
                showSizeChanger={false}
                onChange={onChangePaging}
              />
            </Row>
          </div>
        </Col> : null }
      </Row>
      <Modal
        className="detail-container"
        visible={isOpenComment}
        keyboard={false}
        closable={false}
        title={
          <div
            style={{
              backgroundColor: "orange",
              borderTopLeftRadius: "20px",
              borderTopRightRadius: "20px",
              textAlign: "center",
              color: "white",
              fontSize: "20px",
              height: "50px",
              paddingTop: "15px",
            }}
          >
            {/* ĐÁNH GIÁ */}
            {t("content.rating")}
          </div>
        }
        onCancel={() => {
          setIsOpenComment(false);
          form.setFieldsValue({ comment: "" });
          setEvaluateRating(0);
          setCommentList([]);
        }}
        footer={[]}
      >
        <div>
          <Form form={form} name="commentForm" onFinish={onFinishComment}>
            <Form.Item>
              <Rate              
                defaultValue={5}
                name="rating"
                style={{ marginLeft: "170px", marginBottom: "40px" }}
                value={evaluateRating}
                onChange={onChangeRating}
                allowHalf
              />
            </Form.Item>
            <div>
              <span
                style={{
                  marginLeft: "190px",
                  fontSize: "20px",
                  fontWeight: "500",
                }}
              >
                {/* Bình luận */}
                {t("content.comment")}
              </span>
              <Form.Item name="comment">
                <TextArea style={{ marginTop: "15px" }} rows={6} />
              </Form.Item>
            </div>
            <div style={{ textAlign: "center" }}>
              <Button
                type="primary"
                style={{
                  marginTop: "40px",
                  borderRadius: "20px",
                  width: "160px",
                  height: "50px",
                  backgroundColor: "orange",
                  borderColor: "orange",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
                // size="small"
                className="btn btn-primary"
                form="commentForm"
                key="submit"
                htmlType="submit"
              >
                {/* ĐỒNG Ý */}
                {t("content.ok")}
              </Button>
            </div>
          </Form>
        </div>
      </Modal>
      {/* <LoginModal isOpen={isOpenLogin} handleClose={onCloseLogin} /> */}

      <Modal
        visible={isOpenLogin}
        onCancel={() => {
          stopSpeed()
          setIsOpenLogin(false);
        }}
        footer={null}
        closable={false}
        keyboard={false}
      >
        <Row align="center" style={{ margin: "0 52px" }}>
          <Image
            justifyContent="center"
            src={Logo}
            style={{
              width: 200,
              height: 68,
              margin: "35px 0",
            }}
            alt="Logo"
          />
          {/* <Typography
            style={{
              marginBottom: 24,
              color: "#3E4958",
              fontWeight: 300,
              fontSize: 28,
            }}
          >
            Choose Your Social Network
          </Typography> */}

          <GoogleLogin
            clientId={CLIENT_GOOGLE_ID} //TO BE CREATED
            render={(renderProps) => (
              <Button
                icon={
                  <img
                    style={{ marginRight: 8 }}
                    src="https://img.icons8.com/color/16/000000/google-logo.png"
                  />
                }
                size="large"
                onClick={renderProps.onClick}
                disabled={renderProps.disabled}
                style={{ width: "100%", borderRadius: 10, marginBottom: 24 }}
              >
                 {t("content.loginGoogle")}
              </Button>
            )}
            onSuccess={onSuccessGoogle}
            onFailure={responseGoogle}
            cookiePolicy={"single_host_origin"}
          />
          <FacebookLogin
            appId={FACEBOOK_ID}
            callback={responseFacebook}
            fields="name,email,picture"
            render={(renderProps) => (
              <Button
                type="primary"
                size="large"
                onClick={renderProps.onClick}
                icon={<FacebookFilled />}
                style={{ width: "100%", borderRadius: 10, marginBottom: 24 }}
              >
                 {t("content.loginFaceBook")}
              </Button>
            )}
          />
        </Row>
      </Modal>
    </>
    // </Modal>
  );
}
